import script from "./TableHeaderElectronicInvoice.vue?vue&type=script&setup=true&lang=js"
export * from "./TableHeaderElectronicInvoice.vue?vue&type=script&setup=true&lang=js"

import "./TableHeaderElectronicInvoice.vue?vue&type=style&index=0&id=817a3fbe&lang=css"

const __exports__ = script;

export default __exports__